import React from "react";

const UnauthorizedPage = () => {


    return (
    <>
        <div className="login-page">
    <h1>You are not authorized to view this page.</h1>
    </div>
        </>
    )
};

export default UnauthorizedPage;
